module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropright-circle.f740cc88.svg";